import React from 'react';
import {Link} from "@mui/material";

export default function FileDownload({ fileName, fileId }) {
    const handleDownload = async () => {
        try {
            const response = await fetch(`/api/file/download/${fileId}`, {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error('Failed to download file');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };

    return (
        <Link
            onClick={(event) => {
                event.stopPropagation();
                handleDownload();
            }}

            underline="hover"
        >
            {fileName}
        </Link>
    );
}
